import { render } from "./PsIcon.vue?vue&type=template&id=560435ef"
import script from "./PsIcon.vue?vue&type=script&lang=js"
export * from "./PsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__